import React from 'react';

const Experience = () => {
  return (
    <div className="border-b border-neutral-300 pb-12">
      <h1 className="my-16 text-center lg:text-left text-4xl font-bold text-[#703D99]">Experience</h1>

      <div className="flex flex-wrap lg:justify-center">
        {/* Date Section */}
        <div className="w-full lg:w-1/4 mb-4 lg:mb-0">
          <p className="text-gray-600 text-md font-medium">Dec '24 - Feb '25</p>
        </div>

        {/* Experience Details */}
        <div className="w-full max-w-xl lg:w-3/4 bg-white p-6 rounded-lg shadow-md">
          <h6 className="mb-2 text-lg font-semibold text-[#5A2E7E]">
            Freelance Software Engineer - <span className="text-base text-gray-600">TrinityXR</span>
          </h6>
          <p className="text-gray-700 leading-relaxed">
            As a <strong>Freelance Software Engineer</strong> for Trinity XR, my main focus was on bringing 
            <strong>state-of-the-art computer vision</strong> to life within their flagship Unity application. 
            The core issue was a <strong>compatibility gap</strong> between the high-performance, open-source 
            <strong>Mediapipe framework</strong> and the proprietary Unity environment. My solution was to design and 
            implement a <strong>real-time human tracking system</strong> that could accurately map a user's pose and face. 
            This capability was crucial, directly enabling the <strong>next generation of AR/VR features</strong> 
            that the application needed to succeed.
          </p>

          {/* Tech Stack Badges */}
          <div className="flex flex-wrap gap-2 mt-4">
            {["C++", "Cmake", "Python", "C#", "Unity", "Mediapipe"].map((tech, idx) => (
              <span 
                key={idx} 
                className="rounded-md bg-[#EFE8F6] px-3 py-1 text-sm font-medium text-[#5A2E7E] transition-all duration-300 hover:bg-[#5A2E7E] hover:text-white"
              >
                {tech}
              </span>
            ))}
          </div>
        </div>
      </div>
      <div className="flex flex-wrap lg:justify-center">
        {/* Date Section */}
        <div className="w-full lg:w-1/4 mb-4 lg:mb-0">
          <p className="text-gray-600 text-md font-medium">Mar '24 - Oct '24</p>
        </div>

        {/* Experience Details */}
        <div className="w-full max-w-xl lg:w-3/4 bg-white p-6 rounded-lg shadow-md">
          <h6 className="mb-2 text-lg font-semibold text-[#5A2E7E]">
            Front End Developer - <span className="text-base text-gray-600">Business Quant</span>
          </h6>
          <p className="text-gray-700 leading-relaxed">
            As a <strong>Frontend Developer Intern</strong>, I built <strong>custom WordPress plugins</strong> using PHP and developed 
            <strong> responsive user interfaces</strong> with HTML, CSS, and JavaScript. I designed and customized 
            <strong> WordPress themes</strong> to meet company requirements while enhancing interactivity with 
            <strong> JavaScript and jQuery</strong>. My role also involved <strong>testing and debugging</strong> 
            to ensure smooth user experiences.
          </p>

          {/* Tech Stack Badges */}
          <div className="flex flex-wrap gap-2 mt-4">
            {["JavaScript", "HTML", "PHP", "jQuery", "CSS"].map((tech, idx) => (
              <span 
                key={idx} 
                className="rounded-md bg-[#EFE8F6] px-3 py-1 text-sm font-medium text-[#5A2E7E] transition-all duration-300 hover:bg-[#5A2E7E] hover:text-white"
              >
                {tech}
              </span>
            ))}
          </div>
        </div>
      </div>
      
    </div>
  );
};

export default Experience;
